import Vue from 'vue';
import Router from 'vue-router';
import axios from 'axios';
import ConfiguratorView from '../views/configurator/ConfiguratorView';

Vue.use(Router);

const url =  process.env.URL_BACKEND;
const getAllConfiguratorNamesRest = '/api/configurator/getallconfiguratorsforfrontend';
const urlConfigurationNamesRest = url + getAllConfiguratorNamesRest;
const routes = [];

const router = new Router({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

axios.post(urlConfigurationNamesRest).then((result) => {
  result.data.forEach((element) => {
    router.addRoute({
      path: `/${element.domain}`,
      name: element.name,
      component: ConfiguratorView,
      props: {
        p_configuratorId: element.id,
        p_configuratorName: element.name,
        p_configuratorDomain: element.domain,
      },
    });
  });
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js